
/*******************************************
* Add class params-b2b | params-b2c to body
*******************************************/
document.addEventListener("DOMContentLoaded", (event) => {
  const urlParams = new URLSearchParams(window.location.search);
  const b2b = urlParams.get('b2b') ? urlParams.get('b2b') : 0;
  //console.log( 'theme : b2b : ' + b2b );

  if( b2b ) {
    document.body.classList.add('params-b2b');
    // store this value in a data attribute for Liquid to use
    document.body.setAttribute('data-b2b', b2b);
  }
});

/*******************************************
* Vignettes products 
*******************************************/

(function goToCollectionPage() {
  document.querySelectorAll('.prd-collection').forEach(function(element) {
    element.addEventListener('click', function(event) {
      // Empêcher le comportement par défaut de l'élément parent <a>
      event.preventDefault();
      
      // Empêcher la propagation de l'événement
      event.stopPropagation();

      // Récupérer l'URL à partir de l'attribut data-url
      var url = this.getAttribute('data-url');

      console.log( url );

      // Rediriger vers l'URL si elle existe
      // if (url) {
      //   window.location.href = url;
      // }
    });
  });
})();

/*document.querySelectorAll('a.product-info__caption, .prd-collection').forEach(function(link) {
  link.addEventListener('click', function(event) {
    // Empêcher le comportement par défaut de l'élément parent <a>
    event.preventDefault();
    
    // Empêcher la propagation de l'événement
    event.stopPropagation();

    const collectionElement = event.target.closest('.prd-collection');
    
    if (collectionElement) {
      event.preventDefault(); // Stop the default action
      var url = collectionElement.getAttribute('data-url');
      if (url) {
        //window.location.href = url;
      }
    }
  });
});*/

/*******************************************
* PRODUCT page : Disable unavailable option
*******************************************/

function addOptionAttibute( selectElement )
{
  // Ajoute un écouteur d'événement pour 'change' sur l'élément <select>
  //selectElement.addEventListener('change', function() {
    // Récupère toutes les options de l'élément <select>
    const options = selectElement.options;
  
    // Boucle à travers les options pour supprimer l'attribut 'data-selected'
    for (let i = 0; i < options.length; i++) {
      options[i].removeAttribute('data-selected');
    }
  
    // Ajoute l'attribut 'data-selected' à l'option sélectionnée
    const selectedOption = options[selectElement.selectedIndex];
    selectedOption.setAttribute('data-selected', 'true');
  
    console.log('Option sélectionnée:', selectedOption.textContent);
  //});
}

function addOptionAttibuteOnChange( selectElement )
{
  selectElement.addEventListener('change', function() {
    addOptionAttibute(selectElement);
  });
}

function addOptionAttibuteOnDOMContentLoaded( selectElement )
{
  selectElement.addEventListener('DOMContentLoaded', function() {
    addOptionAttibute(selectElement);
  });
}


function disableSelectOptionBySelectorAndText( selectElement, textToSearch = '' )
{
  //console.log( selectElement );
  
  if( selectElement ) {
    // Récupère toutes les options de l'élément <select>
    const options = selectElement.options;
    
    // Boucle à travers les options pour trouver celle avec le texte spécifique
    for (let i = 0; i < options.length; i++) {
      if( options[i].textContent === textToSearch ) {
        console.log( options[i].textContent + ' => ' + textToSearch );
      
        // disable option
        options[i].setAttribute('disabled', 'disabled');
      }
    }
  }
}
  

const fixVariantOptionsDisable = () => {
  setTimeout(()=>{
    // All variants
    const selectVariants = document.querySelector('[data-variants]');
    const selectOption1 = document.querySelector('[data-option="option1"]');
    const selectOption2 = document.querySelector('[data-option="option2"]');

    if (selectOption1) {
      addOptionAttibuteOnDOMContentLoaded(selectOption1);
      addOptionAttibuteOnChange(selectOption1);
    }
    
    if (selectOption2) {
      addOptionAttibuteOnChange(selectOption2);
    }
    
    if (selectVariants && selectOption2) {
      console.log(selectVariants);

      // On boucle sur les options
      selectVariants.forEach(option => {
        const optionText = option.textContent;

        // Divise la chaîne à partir du caractère '/'
        const parts = optionText.split('/');
        
        // Vérifie si la division a bien fonctionné et récupère la partie après '/'
        if (parts.length > 1) {
          const option1_text = parts[0].trim();
          const option2_text = parts[1].trim();
          
          //console.log('option1_text : ', option1_text);
          //console.log('option2_text : ', option2_text);

          const option2_disable = option.hasAttribute('disabled') ? true : false;
          console.log('---------------------------------------------');
          console.log('option2_text : ' + option2_text + ' : ' + option2_disable );

          if( option2_disable ) {
            //disableSelectOptionBySelectorAndText( selectOption2, option2_text );
          }

        } else {
          console.log('Aucun / trouvé dans la chaîne : ' + optionText);
        }
        
        /*const disable = option.getAttribute('disable');

        console.log( option.textContent + ' : ' + disable  );*/
        

      });
      
    }
    
    // Sélectionne le premier élément avec l'attribut data-option="option1"
    /*const element = document.querySelector('[data-option="option1"]');
    
    // Vérifie si l'élément a été trouvé et fait quelque chose avec lui
    if (element) {
      console.log('Element trouvé:', element);
    } else {
      console.log('Element non trouvé');
    }*/
  })
};


const fixVariantOptionsDisableVersion2 = () => {
  setTimeout(()=>{
    // All variants
    const selectVariants = document.querySelector('[data-variants]');
    const selectOption1 = document.querySelector('[data-option="option1"]');
    const selectOption2 = document.querySelector('[data-option="option2"]');
    
    if (selectVariants && selectOption1 && selectOption2) {
      console.log(selectVariants);

      // On boucle sur les options
      selectVariants.forEach(option => {
        const optionText = option.textContent;

        // Divise la chaîne à partir du caractère '/'
        const parts = optionText.split('/');
        
        // Vérifie si la division a bien fonctionné et récupère la partie après '/'
        if (parts.length > 1) {
          const option1_text = parts[0].trim();
          const option2_text = parts[1].trim();
          
          //console.log('option1_text : ', option1_text);
          //console.log('option2_text : ', option2_text);

          const option2_disable = option.hasAttribute('disabled') ? true : false;
          console.log('---------------------------------------------');
          console.log( optionText );
          console.log('option2_text : ' + option2_text + ' : ' + option2_disable );

          if( option2_disable ) {
            //disableSelectOptionBySelectorAndText( selectOption2, option2_text );
          }

        } else {
          console.log('Aucun / trouvé dans la chaîne : ' + optionText);
        }
        
        /*const disable = option.getAttribute('disable');
        console.log( option.textContent + ' : ' + disable  );*/
      });
    }

  })
};

document.addEventListener("DOMContentLoaded", (event) => {
  /*const selectOption1 = document.querySelector('[data-option="option1"]');

  if (selectOption1) {
    selectOption1.addEventListener('DOMContentLoaded', function() {
      addOptionAttibute(selectElement);
    });
  }*/
  
  //fixVariantOptionsDisable();

  /*fixVariantOptionsDisableVersion2();


  const selectOption1 = document.querySelector('[data-option="option1"]');
  
  if (selectOption1) {
    selectOption1.addEventListener("change", (event) => {
      console.log( 'TEST on change' );

      
      fixVariantOptionsDisableVersion2();
    });
  }*/
});


/*
// gather a list of valid combinations of options, check to see if the input passed to it matches in a chain of valid options.
function validCombo(inputValue, optionLevel) {
  for(let i = 0; i < productJson.length; i++) {
    if(optionLevel == 1){
      if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == inputValue) { return true; }
    } else {
      if (productJson[i].option1 == selectedOptions[0] && productJson[i].option2 == selectedOptions[1] && productJson[i].option3 == inputValue) { return true; }
    }
  }
  return false;
}

function rebuildOptions() {
  selectedOptions = fieldsets.map((fieldset) => {
    return (pickerType == 'radios') ? Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value : Array.from(fieldset.querySelectorAll('select'), (select) => select.value);
  });
  //loop through the option sets starting from the 2nd set and disable any invalid options
  for(let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
    const inputs = (pickerType == 'radios') ? fieldsets[optionLevel].querySelectorAll('input') : fieldsets[optionLevel].querySelectorAll('option');

    inputs.forEach(input => {
      input.disabled = (validCombo(input.value,optionLevel)) ? false : true;
      if(pickerType == 'radios'){
        //get the label for the current input (this is what the user clicks, the "pill")
        const label = fieldsets[optionLevel].querySelector(`label[for="${input.id}"]`);

        label.style.display = (input.disabled) ? "none" : ""; //Hide the option, or comment this line out and use the following lines to style it..
        //label.style.opacity = (input.disabled) ? 0.5 : 1;
        //label.style.borderStyle = (input.disabled) ? "dashed" : "solid";
        //label.style.textDecoration = (input.disabled) ? "none" : "";
      } else {
        input.hidden = (validCombo(input.value,optionLevel)) ? false : true;
      }
    });
  }

  //if the default selected option is disabled with the function above, select the first available option instead
  for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
    if(pickerType == 'radios'){
      if(fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
        change = (fieldsets[optionLevel].querySelector('input:not(:disabled)').checked = true);
      }
    } else {
      if(fieldsets[optionLevel].querySelector('option:checked').disabled === true) {
        change = (fieldsets[optionLevel].querySelector('option:not(:disabled)').selected = "selected");
      }
    }
    //if a new option has been selected, restart the whole process
    if(change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

document.addEventListener("DOMContentLoaded", (event) => {
  const pickerType = (document.querySelector('variant-radios')) ? 'radios' : 'selects';
  //const variantSelects = (pickerType == 'radios') ? document.querySelector('variant-radios') : document.querySelector('variant-selects');
  const variantSelects = (pickerType == 'radios') ? document.querySelector('variant-radios') : document.querySelector('#product-select-variant');

  console.log( variantSelects );
  
  //const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.product-form__input--dropdown'));
  const fieldsets = (pickerType == 'radios') ? Array.from(variantSelects.querySelectorAll('fieldset')) : Array.from(variantSelects.querySelectorAll('.selector-wrapper'));

  console.log( variantSelects.querySelectorAll('.selector-wrapper') );
  //console.log( fieldsets );

  
  const productJson = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
  let selectedOptions = [];
  
  variantSelects.addEventListener('change', rebuildOptions);
  this.rebuildOptions();
});
*/


/*******************************************
* PRODUCT page : onChange select#
*******************************************/
/*
// Fonction pour chercher le SKU en fonction de la valeur sélectionnée
function findSKU(selectedValue) {
  const variants = meta.product.variants;
  console.log( variants );
  
  const variant = variants.find(v => v.public_title === selectedValue);

  console.log( variant );
  
  return variant ? variant.sku : "SKU introuvable";
}

// Fonction qui est exécutée lors du changement de la sélection
function onSelectVariantsChange(event) {
  const selectedValue = event.target.value; // La valeur du <select> sélectionné
  console.log("value : ", selectedValue);
  
  const sku = findSKU(selectedValue);      // Recherche du SKU correspondant
  console.log("SKU correspondant : ", sku);
  
  // Affichage du SKU sur la page si besoin
  document.getElementById("sku-display").textContent = `SKU : ${sku}`;
}*/

//document.addEventListener("DOMContentLoaded", (event) => {
/*document.addEventListener("load", (event) => {
  console.log('page load');
  
  // Ajout de l'écouteur d'événement "change" sur le select
  //document.querySelector('.single-option-selector').addEventListener('change', onSelectVariantsChange);

  const selectElement = document.querySelector('.single-option-selector');
  
  if (selectElement) {
    // Ajout de l'écouteur d'événement "change" sur le select si trouvé
    //selectElement.addEventListener('change', onSelectVariantsChange);

    console.log('select change');
    
  } else {
    console.error('.single-option-selector non trouvé sur la page');
  }
});*/

/*
setTimeout(()=>{
  console.log('page load');
  
  // Ajout de l'écouteur d'événement "change" sur le select
  //document.querySelector('.single-option-selector').addEventListener('change', onSelectVariantsChange);

  const selectElement = document.querySelector('.single-option-selector');
  
  if (selectElement) {
    console.log('select exist');
    
    // Ajout de l'écouteur d'événement "change" sur le select si trouvé
    selectElement.addEventListener('change', onSelectVariantsChange);

    
  } else {
    console.error('.single-option-selector non trouvé sur la page');
  }
}, 1000);
*/


/*============================================================================
  Product
==============================================================================*/
/*window.selectCallback = function (variant, selector, $element) {
  const evt = document.createEvent('HTMLEvents');
  let $product;
  if ($element) {
    $product = $element.find(`.product-${selector.product.id}`);
  } else {
    $product = $(`.product-${selector.product.id}`);
  }
  const $productForm = $('.product_form, .shopify-product-form', $product);
  const variantInventory = $productForm.data('variant-inventory');

  // Manually trigger change event so
  // pure JS listeners can receive it
  evt.initEvent('change', false, true);
  selector.variantIdField.dispatchEvent(evt);

  console.log( variant );
  
  if (variant) {
    $('.variant-sku', $product).text(variant.sku);
  }
};*/

/*******************************************
* COLLECTION page : drawer FILTERS
*******************************************/
document.addEventListener("DOMContentLoaded", function() {
    // Lorsque l'élément avec #js-drawer-open-filters est cliqué
    const openButton = document.getElementById("js-drawer-open-filters");
    const filterDrawer = document.getElementById("FilterDrawer");

    if (openButton && filterDrawer) {
        openButton.onclick = function() {
            // Ajouter la classe "drawer--is-open" à l'élément avec l'ID "FilterDrawer"
            filterDrawer.classList.add("drawer--is-open");
        };

        // Lorsque n'importe quel élément avec la classe "js-drawer-close" est cliqué
        document.querySelectorAll(".js-drawer-close").forEach(function(element) {
            element.onclick = function() {
                // Retirer la classe "drawer--is-open" de l'élément avec l'ID "FilterDrawer"
                filterDrawer.classList.remove("drawer--is-open");
            };
        });
    }
});


/*******************************************
* Smooth Scrolling : Go To Anchor
*******************************************/
function smoothScroll(target) {
  const element = document.getElementById(target);
  if (element) {
    window.scrollTo({
      top: element.offsetTop,
      behavior: 'smooth'
    });
  }
}

document.addEventListener('DOMContentLoaded', function() {
  //const anchors = document.querySelectorAll('.go-to-anchor');
  const anchors = document.querySelectorAll('a[href^="#"]');
  anchors.forEach(function(anchor) {
    anchor.addEventListener('click', function(event) {
      event.preventDefault();
      const target = anchor.getAttribute('href').substring(1);
      smoothScroll(target);
    });
  });
});


/***************************
 * Cart B2B exempt TVA 
 **************************/
/*window.addEventListener("DOMContentLoaded", (event) => {
  const btnCartTva = document.querySelector("#btn-submit-tva");
  const cartForm = document.querySelector("#cart_form");

  // Submit #form-sticky => Submit #form-date-gregorienne
  if( btnCartTva && cartForm ) {
    btnCartTva.addEventListener("click", event => {
      //console.log(event);
      //event.preventDefault();

      cartForm.submit();
    });
  }
});*/